import { initApp } from '~/helpers/app';

initApp('#sandbox-app', '/sandbox', true);
